<template>
    <base-spinner :open="isloading"></base-spinner>
    <div class="checkout__payment-methods payment-methods">
        <ul class="payment-methods__list">
            <li class="payment-methods__item" :class="classOpen">
                <label class="payment-methods__item-header">
                    <span class="payment-methods__item-radio input-radio">
                        <span class="input-radio__body">
                            <input class="input-radio__input" name="checkout_payment_method" type="checkbox" @change="isOpen = !isOpen" :checked="isOpen">
                            <span class="input-check"></span>
                        </span>
                    </span>
                    <span class="payment-methods__item-title">Apply a Promotional Code</span>
                </label>
                <div class="payment-methods__item-container" v-if="(isOpen == true)">
                    <div class="checkout__payment-methods checkout__payment-methods-cc-accordian">
                        <div class="form-row">                                        
                            <div class="form-group col-md-6">
                                <label for="checkout-promo-code">Enter Promotional Code</label>
                                <input type="text" class="form-control" id="checkout-last-name" placeholder="" v-model="code" @keypress.enter="validate_code" @keypress="reset">
                            </div>
                            <div class="form-group col-md-6 button-promo-align">
                                <button class="btn btn-xs btn-grey" type="button" @click="validate_code">Apply</button>
                            </div>
                            <div class="valid-promo-feedback" v-if="promo_accepted">{{ success_msg }}</div>
                            <div class="invalid-promo-feedback" v-if="error_code">{{error_msg}}</div>
                        </div>	
                        <div class="form-row">
                            <div class="valid-feedback">
                                Promotion ACD20 applied.<br>
                                20% off select ACDelco products.	
                            </div>
                        </div>

                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            isloading: false,
            isOpen: false,
            code: '',
            error_code: false,
            promo_accepted: false,

            error_msg: '',
            success_msg: '',
        }
    },
    computed: {
        classOpen() {
            if (this.isOpen){
                return 'payment-methods__item--active';
            }else{
                return '';
            }
        },
        ...mapGetters('cart',[
            'promo_code'
        ])
    },

    methods: {
        reset() {
            this.error_code = false;   
            this.promo_accepted = false;
        },
        validate_code() {
            this.isloading = true;
            this.error_msg = '';
            this.success_msg = '';

            this.code = this.code.toUpperCase();

            const isApplied = this.promo_code.find(promo => promo.code == this.code);
            // this.$store.dispatch('cart/emptyPromo');

            if(isApplied != undefined){
                this.error_code = true;
                this.error_msg = 'Promo code ' + this.code + ' is already applied.'
                this.isloading = false;
                return false;
            }

            axiosvl.post(this.$store.getters['api/promo_code_uri'], 
				{
					"webroutine": {
						"context": {
							"session-key-method": "hidden"
						},
						"fields": {
							// "HOSTURL": {"value": this.$store.getters.hosturl},
                            "LW3SFID": { "value": this.$store.getters.storefront },
							"LW3PROCOD": {"value": this.code},
						}
					}
				}
			).then((response) => { 
                this.isloading = false;
				const fields = response.data.webroutine.fields;
                const DC_DETAILS = response.data.webroutine.lists.DC_DETAILS.entries;

                // console.log(DC_DETAILS);
				if (fields.RET_CODE.value == 'ER'){
                    this.error_code = true;
                    this.error_msg = 'Promo code ' + this.code + ' is invalid.'
                    this.promo_accepted = false;

                }else{


                    this.error_code = false;
                    this.promo_accepted = true;
                    this.success_msg = 'Promo code ' + this.code + ' successfully applied.';

                    DC_DETAILS.forEach(dc => {
                        // console.log(dc);

                        // UPDATE ORDER TOTAL
                        const promo_details = {
                            main_desc : fields.LW3PRONM.value,
                            code    : this.code,
                            fixed_dc: dc.LW3DOLDIS,
                            percent_dc: dc.LW3PCTDIS,
                            to_item: dc.LW3ITEMCD,
                            to_sag: dc.LW3SSHPTP,
                            sequence: dc.LW3SEQ,
                            amnt_dc: 0,
                        };

                        // console.log(promo_details);

                        // set promo code to the state
                        this.$store.dispatch('cart/setPromo_code', promo_details);// UPDATE ORDER TOTAL
                    });

                    // // recalculate the totals
                    this.$store.dispatch('cart/calculateTotals');
                }

			}).catch(function (error) { 
				console.error("error - " + error);
			});
        }
    },
    created() {
        // if (this.promo_code.code != ''){
        //     this.code = this.promo_code.code;
        //     this.promo_accepted = true;
        //     this.isOpen = true;
        // }
    },
    updated() {
    }
}
</script>